<template>
  <div>
    <div class="logo-size">
      <!-- eslint-disable max-len -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 101.224 32.286">
        <g
          class="logo-brand"
          word-spacing="0"
          letter-spacing="0"
          font-size="27.12"
          font-weight="400"
        >
          <path
            overflow="visible"
            d="M91.75 15.77c-2.884 0-5.326.987-7.175 2.929-1.862 1.947-2.775 4.644-2.775 7.968 0 1.79.396 3.5 1.18 5.105a9.173 9.173 0 0 0 3.515 3.864c1.544.942 3.307 1.415 5.24 1.415 1.79 0 3.478-.426 5.028-1.266h.002c1.568-.86 2.795-2.14 3.643-3.789.845-1.644 1.263-3.506 1.263-5.553 0-2.016-.4-3.847-1.206-5.464l-.002-.002c-.802-1.63-1.991-2.925-3.534-3.838-1.54-.912-3.283-1.37-5.18-1.37zm.013 3.453c1.177 0 2.2.29 3.128.878l.003.002.003.002c.93.577 1.623 1.378 2.109 2.458l.002.004v.002c.496 1.074.754 2.356.754 3.86 0 2.388-.592 4.133-1.72 5.35l-.001.001c-1.14 1.237-2.527 1.831-4.319 1.831-1.754 0-3.136-.586-4.293-1.808l-.002-.002c-1.133-1.215-1.718-2.874-1.718-5.095 0-2.821.64-4.708 1.773-5.78 1.215-1.152 2.601-1.703 4.28-1.703zM103.737 16.114v20.605h3.829v-7.87h4.368c2.84 0 4.93-.569 6.169-1.904l.002-.002c1.154-1.254 1.745-2.83 1.745-4.608 0-1.043-.22-2.023-.66-2.912v-.002c-.429-.88-1.02-1.595-1.763-2.101-.734-.51-1.625-.84-2.648-1.011h-.004c-.75-.135-1.758-.195-3.069-.195zm3.829 3.53h4.354c1.146 0 1.938.073 2.238.151.54.15.94.429 1.272.902l.002.006.003.004c.334.46.506 1.004.506 1.708 0 .989-.28 1.642-.838 2.135-.515.453-1.544.767-3.13.767h-4.407v-5.674zM121.916 16.114V27.92c0 2.102.247 3.794.791 5.1v.002c.548 1.303 1.492 2.327 2.764 3.013 1.28.69 2.877 1.015 4.772 1.015 1.957 0 3.593-.372 4.873-1.165h.002c1.256-.782 2.163-1.831 2.656-3.105.485-1.255.705-2.867.705-4.86V16.114h-3.829v11.793c0 2.362-.437 3.861-1.04 4.5-.638.676-1.792 1.085-3.592 1.085-1.024 0-1.848-.198-2.507-.567-.648-.368-1.074-.854-1.343-1.521l-.002-.002c-.256-.666-.421-1.855-.421-3.494V16.114ZM148.86 15.783c-1.38 0-2.656.232-3.81.707-1.167.48-2.098 1.21-2.729 2.176a5.526 5.526 0 0 0-.94 3.075c0 .994.26 1.927.772 2.746l.004.004.002.004c.53.82 1.317 1.487 2.32 2.01.821.433 2.093.834 3.902 1.27h.002c1.78.42 2.95.743 3.384.912l.002.002h.002c.747.282 1.225.618 1.48.946l.001.002.002.002c.27.342.398.715.398 1.202 0 .47-.135.88-.439 1.297v.002h-.002c-.277.383-.72.713-1.39.972-.667.258-1.456.394-2.376.394-1.034 0-1.94-.177-2.738-.518h-.002c-.803-.352-1.348-.786-1.692-1.284-.347-.523-.59-1.217-.696-2.111l-.07-.602-3.623.315.015.587c.039 1.397.428 2.684 1.164 3.81l.002.002v.003c.747 1.12 1.789 1.971 3.075 2.525h.002c1.297.554 2.86.818 4.682.818 1.466 0 2.809-.268 4.005-.81h.002c1.206-.552 2.165-1.342 2.827-2.353v-.002h.002c.65-1.005.989-2.108.989-3.257 0-1.145-.307-2.197-.917-3.093l-.002-.002c-.618-.916-1.556-1.645-2.765-2.2h-.004c-.877-.395-2.323-.8-4.434-1.27-2.058-.467-3.343-1.009-3.596-1.238l-.002-.002-.002-.002c-.385-.342-.549-.707-.549-1.252 0-.619.232-1.087.827-1.56h.002c.544-.435 1.539-.723 3.02-.723 1.408 0 2.38.3 2.987.797h.002l.002.002c.628.51 1.006 1.25 1.126 2.356l.066.6 3.676-.274-.023-.602c-.048-1.237-.402-2.375-1.058-3.368-.663-1.005-1.626-1.767-2.828-2.265-1.189-.506-2.545-.75-4.056-.75z"
            transform="translate(-56.165 -11.718)" />
        </g>
        <g
          class="g-circle"
          transform="translate(-1.302 -1.712) scale(.04942)">
          <circle
            class="logo-symbol-circle"
            cx="257.723"
            cy="108.859"
            r="74.21" />
          <g class="logo-symbol">
            <path
               class="logo-symbol-right"
              d="M433.124 130.113c-2.3.033-4.61.226-6.921.585-15.5 2.41-12.237-.248-101.307 82.623-21.247 19.767-26.354 24.421-42.033 38.958 3.98 3.679 19.828 18.385 19.908 18.455 18.861 16.748 31.838 41.026 31.838 65.642 0 22.76-12.042 46.699-29.621 63.269-5.31 5.004-14.67 13.714-22.209 20.755 53.341 49.575 122.692 113.54 124.823 114.95 9.18 6.076 25.258 8.736 36.856 6.096 8.866-2.018 16.92-6.28 23.735-12.568 17.958-16.566 22.11-39.36 11.209-61.501-3.073-6.242-6.492-10.04-31.587-35.007-15.48-15.4-43.18-43.346-61.554-62.107l-33.406-34.118 62.254-62.882c68.955-69.657 65.935-66.044 69.427-83.166 2.71-13.292-.743-27.432-9.536-39.052-10.234-13.527-25.767-21.161-41.876-20.933z" />
            <path
              class="logo-symbol-left"
              d="M73.472 541.443c-8.866-2.018-16.914-6.28-23.73-12.568-17.958-16.567-22.114-39.358-11.214-61.5 3.073-6.242 6.494-10.033 31.59-35 15.479-15.4 43.177-43.35 61.55-62.113l33.408-34.112-62.254-62.888c-68.956-69.656-65.934-66.037-69.426-83.159-2.71-13.292.741-27.433 9.534-39.054 11.696-15.459 30.316-23.222 48.803-20.348 15.5 2.41 12.23-.256 101.3 82.615 44.566 41.464 84.24 78.24 88.163 81.724 14.47 12.848 20.914 25.585 20.914 41.335 0 15.711-5.111 26.144-19.412 39.624-42.033 39.62-169.473 157.433-172.37 159.35-9.181 6.076-25.257 8.734-36.856 6.094z" />
          </g>
        </g>
        <g
          class="logo-by-line"
>
          <path
            d="M2.283 27.062q.952 0 1.472.664.52.656.52 1.952 0 1.288-.528 1.952-.52.656-1.464.656T.82 31.63Q.3 30.966.3 29.678q0-1.296.52-1.952.52-.664 1.464-.664zm0 .6q-.616 0-.96.464T.98 29.494v.368q0 .904.344 1.368.344.464.96.464t.96-.464q.352-.464.352-1.368v-.368q0-.904-.352-1.368-.344-.464-.96-.464zM9.41 32.198 7.52 28.99q-.08-.136-.192-.368-.104-.24-.136-.32l-.024.008q.008.08.016.288.016.2.016.392v3.208h-.584v-5.04h.56l1.872 3.168q.072.12.176.36.112.232.144.312l.016-.008-.016-.664v-3.168h.568v5.04zM15.143 31.606v.592H12.44v-5.04h.656v4.448zM17.261 27.158h.656v5.04h-.656zM23.203 32.198l-1.888-3.208q-.08-.136-.192-.368-.104-.24-.136-.32l-.024.008q.008.08.016.288.016.2.016.392v3.208h-.584v-5.04h.56l1.872 3.168q.072.12.176.36.112.232.144.312l.016-.008-.016-.664v-3.168h.568v5.04zM29.345 27.158v.584H26.89v1.576h2.136v.592H26.89v1.696h2.504v.592h-3.16v-5.04zM37.581 31.606v.592h-2.704v-5.04h.656v4.448zM42.811 27.158v.584h-2.456v1.576h2.136v.592h-2.136v1.696h2.504v.592H39.7v-5.04zM48.01 32.198l-.345-1.12h-2l-.344 1.12h-.648l1.608-5.04h.832l1.592 5.04zm-1.36-4.52q-.009.064-.049.264-.032.192-.064.296l-.688 2.248h1.632l-.68-2.248q-.032-.104-.072-.296-.04-.2-.048-.264zM52.72 27.158q.727 0 1.111.376.392.376.392 1.016 0 .472-.24.816-.232.344-.656.488l1.016 2.344h-.712l-.944-2.232h-1.344v2.232h-.656v-5.04zm-1.377 2.216h1.352q.392 0 .624-.224.232-.224.232-.6 0-.384-.224-.592-.216-.216-.632-.216h-1.352zM59.301 32.198l-1.888-3.208q-.08-.136-.192-.368-.104-.24-.136-.32l-.024.008q.008.08.016.288.016.2.016.392v3.208h-.584v-5.04h.56l1.872 3.168q.072.12.176.36.112.232.144.312l.016-.008-.016-.664v-3.168h.568v5.04zM62.331 27.158h.656v5.04h-.656zM68.273 32.198l-1.888-3.208q-.08-.136-.192-.368-.104-.24-.136-.32l-.024.008q.008.08.016.288.016.2.016.392v3.208h-.584v-5.04h.56l1.872 3.168q.072.12.176.36.112.232.144.312l.016-.008-.016-.664v-3.168h.568v5.04zM73.04 29.566h1.967v2.632h-.432l-.136-.56q-.432.648-1.304.648-.968 0-1.48-.656-.504-.656-.504-1.952 0-1.296.528-1.952.528-.664 1.488-.664.832 0 1.336.464.504.464.504 1.344h-.664q0-.608-.312-.904-.312-.304-.864-.304-.632 0-.984.464t-.352 1.368v.368q0 .92.328 1.376.336.456.976.456.624 0 .912-.352.296-.36.296-1.08v-.128H73.04zM81.171 31.606h2.456v.592H80.26v-.28l2.392-4.176h-2.248v-.584h3.176v.272zM87.609 27.062q.952 0 1.472.664.52.656.52 1.952 0 1.288-.528 1.952-.52.656-1.464.656t-1.464-.656q-.52-.664-.52-1.952 0-1.296.52-1.952.52-.664 1.464-.664zm0 .6q-.616 0-.96.464t-.344 1.368v.368q0 .904.344 1.368.344.464.96.464t.96-.464q.352-.464.352-1.368v-.368q0-.904-.352-1.368-.344-.464-.96-.464zM94.735 32.198l-1.888-3.208q-.08-.136-.192-.368-.104-.24-.136-.32l-.024.008q.008.08.016.288.016.2.016.392v3.208h-.584v-5.04h.56l1.872 3.168q.072.12.176.36.112.232.144.312l.016-.008-.016-.664v-3.168h.568v5.04zM100.877 27.158v.584h-2.456v1.576h2.136v.592h-2.136v1.696h2.504v.592h-3.16v-5.04z" />
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpusLogo"
};
</script>

<style scoped>
.g-circle {
  paint-order: stroke markers fill
}
.logo-brand {
  color: #000;
  font-weight: 400;
  font-size: 27.12000084px;
  line-height: 125%;
  font-family: Arial;
  letter-spacing: 0;
  word-spacing: 0;
  fill: #eb690c;
  stroke: none;
  stroke-width: 1.25;
}

.logo-brand path {
  line-height: 125%;
              -inkscape-font-specification: 'Arial, Normal';
              font-variant-ligatures: normal;
              font-variant-position: normal;
              font-variant-caps: normal;
              font-variant-numeric: normal;
              font-variant-alternates: normal;
              font-feature-settings: normal;
              text-indent: 0;
              text-align: start;
              text-decoration: none;
              text-decoration-line: none;
              text-decoration-style: solid;
              text-decoration-color: #000;
              text-transform: none;
              text-orientation: mixed;
              white-space: normal;
              shape-padding: 0;
              overflow: visible;
              isolation: auto;
              mix-blend-mode: normal;
              solid-color: #000;
              solid-opacity: 1;
}

.logo-size {
  overflow: hidden;
  height: 0;
  width: 100%;
  padding-bottom: 33.070866%;
}
.logo-symbol-left {
  fill: #4e4e4d;
  fill-opacity: 0;
  animation-name: slideright;
  animation-delay: 300ms;
  animation-duration: 200ms;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
}

@keyframes slideright {
  from {
    fill-opacity: 0;
    transform: translateX(-30px);
  }
  to {
    fill-opacity: 1;
    transform: translateX(0);
  }
}

.logo-symbol-right {
  fill: gray;
  fill-opacity: 0;
  animation-name: slideleft;
  animation-delay: 300ms;
  animation-duration: 200ms;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
}

@keyframes slideleft {
  from {
    fill-opacity: 0;
    transform: translateX(30px);
  }
  to {
    fill-opacity: 1;
    transform: translateX(0);
  }
}

.logo-symbol {
  transform-box: fill-box;
  transform-origin: 50%;
  animation-name: rotating;
  animation-delay: 400ms;
  animation-duration: 1000ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
}

@keyframes rotating {
  from {
    transform: rotate3d(0, 1, 0, 0deg);
  }
  to {
    transform: rotate3d(0, 1, 0, 360deg);
  }
}

.logo-symbol-circle {
  fill: #eb690c;
  fill-opacity: 0;
  transform-box: fill-box;
  transform-origin: 50% 50%;
  animation-name: fadescalecircle;
  animation-delay: 1000ms;
  animation-duration: 500ms;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
}

@keyframes fadescalecircle {
  from {
    fill-opacity: 0;
    transform: scale(0);
  }
  to {
    fill-opacity: 1;
    transform: scale(1);
  }
}

.logo-brand {
  fill-opacity: 0;
  transform-box: fill-box;
  transform-origin: 50% 50%;
  animation-name: fadescalebrand;
  animation-delay: 1100ms;
  animation-duration: 1000ms;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
}

@keyframes fadescalebrand {
  from {
    fill-opacity: 0;
    transform: scale(0.9);
  }
  to {
    fill-opacity: 1;
    transform: scale(1);
  }
}

.logo-by-line {
  fill: gray;
            stroke: none;
            stroke-width: 1px;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke-opacity: 1;
  fill-opacity: 0;

  transform-box: fill-box;
  transform-origin: 50% 50%;
  animation-name: fadescalebyline;
  animation-delay: 1800ms;
  animation-duration: 1000ms;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
}

@keyframes fadescalebyline {
  from {
    fill-opacity: 0;
    stroke-opacity: 0;
    transform: scale(0.95);
  }
  to {
    fill-opacity: 1;
    stroke-opacity: 1;
    transform: scale(1);
  }
}
</style>
